import VideoForm from "./VideoForm.container";

export default VideoForm;
